import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import config from "./config";

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface CustomerState {
    headerFooterError: boolean;
	header: string;
	footer: string;
	style: string;
  script: string;
}

interface GetHeaderFooterResponse {
    header: string;
    footer: string;
    style: string;
    script: string;
}

const defaultState: CustomerState = {
    headerFooterError: false,
	header: "",
	footer: "",
	style: "",
  script: ""
};

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

export interface GetHeaderFooterAction { type: 'GET_HEADER_FOOTER' }
export interface GettingHeaderFooterAction { type: 'GETTING_HEADER_FOOTER' }
export interface GetHeaderFooterCompletedAction { type: 'GET_HEADER_FOOTER_COMPLETED', payload: GetHeaderFooterResponse }
export interface GetHeaderFooterFailedAction { type: 'GET_HEADER_FOOTER_FAILED', payload: { headerFooterError: boolean } }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = GetHeaderFooterAction | GetHeaderFooterCompletedAction | GetHeaderFooterFailedAction | GettingHeaderFooterAction;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {

    getHeaderFooter: (): AppThunkAction<KnownAction> => (dispatch, getState) => {

        //Get Header and Footer for ABG
        if (!config.brand || (config.brand && config.brand) === 'abg') {
            fetch("https://www.alanboswell.com/api/theme/page-elements")
              .catch(reason => { debugger; console.log(reason); return null; })  
                .then(async response => {
                    if (response) {
                        try{
                            let resp = (await response.json()) as GetHeaderFooterResponse;
                            return Promise.resolve(resp); 
                        }catch(error) {
                            console.log(error);
                            return Promise.reject(error);
                        }
                    }
                })
                .then(data => {
                    if (data) {
                        dispatch({ type: 'GET_HEADER_FOOTER_COMPLETED', payload: data });
                    } else {
                        dispatch({ type: 'GET_HEADER_FOOTER_FAILED', payload: { headerFooterError: true } })
                    }
                }).catch(reason => {
                    dispatch({ type: 'GET_HEADER_FOOTER_FAILED', payload: { headerFooterError: true } })
                });
        }

        //Get Header and Footer for S-TECH
        if (config.brand && config.brand === 'stech') {
            fetch("https://www.s-tech.co.uk/api/theme/page-elements")
                .catch(reason => { debugger; console.log(reason); return null; })
                .then(async response => {
                    try {
                        let resp = (await response.json()) as GetHeaderFooterResponse;
                        return Promise.resolve(resp);
                    }catch(error) {
                        console.log(error);
                        return Promise.reject(error);
                    }
                })
                .then(data => {
                    if (data) {
                        dispatch({ type: 'GET_HEADER_FOOTER_COMPLETED', payload: data });
                    } else {
                        dispatch({ type: 'GET_HEADER_FOOTER_FAILED', payload: { headerFooterError: true } })
                    }
                }).catch(reason => dispatch({ type: 'GET_HEADER_FOOTER_FAILED', payload: { headerFooterError: true } }));
        }

    },
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

export const reducer: Reducer<CustomerState> = (state: CustomerState | undefined, incomingAction: Action): CustomerState => {
    if (state === undefined) {
        return defaultState;
    }

    const action = incomingAction as KnownAction;
    //console.log(action);
	switch (action.type) {
		case "GET_HEADER_FOOTER_COMPLETED":
			console.log("get header footer completed")
            return { ...state, ...action.payload, headerFooterError: false }
		case "GET_HEADER_FOOTER_FAILED":
			console.log('get header footer failed')
            return { ...state, headerFooterError: true }
        default:
            return state;
    }
};
